export var PreFormInfoKeys;
(function (PreFormInfoKeys) {
    PreFormInfoKeys["TITLE"] = "title";
    PreFormInfoKeys["SLUG"] = "slug";
    PreFormInfoKeys["DESCRIPTION"] = "description";
    PreFormInfoKeys["CALLBACK_URL"] = "callbackURL";
    PreFormInfoKeys["CALLBACK_INCLUDE_USER_AUTH"] = "callbackIncludeUserAuth";
    PreFormInfoKeys["AUTH_REQUIRED"] = "authRequired";
})(PreFormInfoKeys || (PreFormInfoKeys = {}));
